import { ref } from 'vue'

const paymentNotifications = ref({})

export default function usePaymentNotifications() {
  const displayPaymentNotification = newNotification => {
    const newId = Date.now()
    if (paymentNotifications.value[newId]) return

    paymentNotifications.value[newId] = { ...newNotification, id: newId }
  }

  const closePaymentNotification = id => {
    removePaymentNotification(id)
  }

  const removePaymentNotification = id => {
    if (paymentNotifications.value[id]) delete paymentNotifications.value[id]
  }

  const clearAllNotifications = () => {
    paymentNotifications.value = {}
  }

  return {
    paymentNotifications,
    displayPaymentNotification,
    closePaymentNotification,
    clearAllNotifications,
  }
}
